import { FaExclamationTriangle } from "react-icons/fa";
import { FaRotateRight } from "react-icons/fa6";

const ChartsErrorComponents = () => {
    return (
        <div
            role="alert"
            style={{
                position: "relative",
                top: 0,
                bottom: 0,
                right: 0,
                background: "rgb(229, 228, 226,0.4)",
                marginTop: "0.9rem",
            }}
        >
            <div
                className="text-center"
                style={{
                    display: "grid",
                    justifyContent: "center",
                    padding: "7vh",
                    color: "#808080",
                }}
            >
                <FaExclamationTriangle style={{ fontSize: `6vw` }}/>
                <div style={{ fontSize: `1.2vw`, marginTop: "1rem" }}>
                    <div>Failed to load the component !</div>
                    <FaRotateRight 
                        style={{ cursor: "pointer" }}
                        onClick={() => window.location.reload()}/>
                </div>
            </div>
        </div>
    );
};

export default ChartsErrorComponents;
